import { PageShell } from "@/components/layout/PageShell";
import { Seo } from "@/components/Seo";
import { Products } from "@/components/home/Products";
import { CardamomGrading } from "@/components/home/CardamomGrading";
import { Credentials } from "@/components/home/Credentials";
import { breadcrumbSchema, productListSchema } from "@/lib/schema";

export default function ProductsPage() {
  return (
    <>
      <Seo
        title="Products & Cardamom Grades | Nandanaaya Spices Hyderabad"
        description="Wholesale green cardamom by indicative grade, black pepper, nutmeg, mace, cloves, bay leaves, dry coconut and other whole spices. Request current availability and quotation."
        path="/products"
        jsonLd={{
          "@context": "https://schema.org",
          "@graph": [productListSchema(), breadcrumbSchema([{ name: "Products", url: "/products" }])],
        }}
      />
      <PageShell
        testid="products-page"
        title="Products & Cardamom Grades"
        subtitle="Wholesale lots of green cardamom, black pepper and selected whole spices. Grade, quantity and rate are confirmed against the lot currently available."
        breadcrumbs={[{ label: "Products" }]}
      >
        <Products
          heading="Wholesale Spice Range"
          intro="Each product is supplied in wholesale quantities. Click Request Quote to send your grade and quantity requirement, or ask on WhatsApp."
        />
        <CardamomGrading showGallery />
        <Credentials />
      </PageShell>
    </>
  );
}
